module.exports = __webpack_public_path__ + "img/uc3.7dcae67a.png";